const METRICS = {
  fe_dtf_image_uploads: "fe_dtf_image_uploads",
  fe_dtf_image_processed: "fe_dtf_image_processed",
  fe_dtf_image_processing_cancelled: "fe_dtf_image_processing_cancelled"
};

const getDatadogRum = () => window.DD_RUM || null;

const sendMetric = async (name, labels = {}) => {
  try {
    const datadogRum = getDatadogRum();
    if (!datadogRum || typeof datadogRum.addAction !== "function") {
      // eslint-disable-next-line no-console
      console.warn("Datadog RUM is not available, skipping metric:", name);
      return;
    }

    datadogRum.addAction(name, {
      ...labels,
      count: 1
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error sending metric:", error);
  }
};

const trackImageUpload = (businessLine, fileType, pageType) => {
  sendMetric(METRICS.fe_dtf_image_uploads, {
    business_line: businessLine || "unknown",
    file_type: fileType || "unknown",
    page_type: pageType || "unknown"
  });
};

const trackImageProcessed = fileType => {
  sendMetric(METRICS.fe_dtf_image_processed, {
    file_type: fileType || "unknown"
  });
};

const trackImageProcessingCancelled = (catalogNumber, action) => {
  sendMetric(METRICS.fe_dtf_image_processing_cancelled, {
    catalog_number: catalogNumber || "unknown",
    action: action || "unknown"
  });
};

const datadogTracker = {
  trackImageUpload,
  trackImageProcessed,
  trackImageProcessingCancelled
};

export default datadogTracker;
